import { useMemo } from "react";
import { Box } from "@mui/material";
import { Form, Formik } from "formik";
import CustomDrawer from "@shared/components/form-components/CustomDrawer";
import { FormTextField, FormFooter } from "@shared/components";
import {
  TitleFormInitialValues,
  TitleFormFields,
  validationSchema,
} from "../utils/constants";
import { AddUpdateTitleFormProps, TitleFormValues } from "../utils/types";
import TitleSwitches from "./TitleSwitches";

const TitleForm = ({
  open,
  onClose,
  title,
  showCloseButton,
  initialValues,
  onSubmit,
  disable,
}: AddUpdateTitleFormProps) => {
  const mergedInitialValues = useMemo(
    () => ({
      ...TitleFormInitialValues,
      ...initialValues,
    }),
    [initialValues]
  );

  return (
    <CustomDrawer
      open={open}
      onClose={onClose}
      title={title}
      showCloseButton={showCloseButton}
    >
      <Formik
        enableReinitialize
        initialValues={mergedInitialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formikProps) => (
          <Form
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              overflow: "hidden",
              paddingBottom: "80px",
            }}
          >
            <Box
              sx={{
                position: "relative",
                p: 2,
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                overflowX: "hidden",
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              {TitleFormFields.map(({ name, label }) => (
                <FormTextField
                  key={name}
                  name={name}
                  label={label}
                  value={String(
                    formikProps.values[name as keyof TitleFormValues]
                  )}
                  onChange={formikProps.handleChange}
                  touched={formikProps.touched as Record<string, unknown>}
                  errors={formikProps.errors as Record<string, unknown>}
                />
              ))}
              <TitleSwitches formikProps={formikProps} />
            </Box>
            <FormFooter
              disable={disable || !formikProps.dirty}
              isSubmitting={formikProps.isSubmitting}
            />
          </Form>
        )}
      </Formik>
    </CustomDrawer>
  );
};

export default TitleForm;
